import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const bannerThematicRolesRBAC = {
  pageID: '695a5483e65616f01a0932fe681d79e2',
  elementID: {
    ViewPage: '772784a2b1dfae19ad3372c625b0add4',
    ButtonCreateBanner: '540b215449e8bdb67e5b72a9ef43fad3',
    ButtonEditBanner: 'cf1c32b1b7dee8fd131164322ed44980',
    ButtonToggleStatusBanner: '5efb598d5e86ac121b5f8b744edd7972',
  },
} as const

export const useRBACBannerThematicPage = createUseRBAC(bannerThematicRolesRBAC.elementID)

export type UseRBACBannerThematicPageType = ReturnType<typeof useRBACBannerThematicPage>
